<template>
  <div class="shegong-wrapper" :style="{width:width*0.29+'px'}">
    <div class="sg-head">社工办理</div>
    <y-scroll :contentArr="shegong" :height="height * 0.79" :lineNum="1" :width="width*0.29" :startTime="3000" v-if="shegong.length">
      <div class="sg-item" slot="scroll" slot-scope="props">
        <img  class="sg-pic" :src="props.todo.headPic" :style="{width:height * 0.79}">
        <div class="sg-info" :style="{fontSize:no125?'15px':'12px'}">
          <p class="info-name" style="color:#666e83">{{props.todo.name}}</p>
          <p class="duohang-slh">{{props.todo.content}}</p>
          <p class="info-foot" :style="{fontSize:no125?'13px':'11px'}">网格员办理事件公示</p>
        </div>
      </div>
    </y-scroll>
  </div>
</template>

<script>
  import yScroll from '../../../components/yScroll'
  export default {
    components: {
      yScroll
    },
    computed: {
      no125 () {
        return this.height/0.215>750 || this.width > 1550?true:false
      },
    },
    props:{
      height:null,
      width:null,
      shegong:null
    },
    data () {
      return {

      }
    }
  }
</script>

<style scoped>
.shegong-wrapper{
  /*width:575px;*/
  background: #fff;
  border:1px solid #fff;
  border-radius: 5px;
  padding-top: 15px;
  color:#444;
}
  .sg-head{
    /*height: 20px;*/
    /*line-height: 20px;*/
    border-left: 3px solid #d22b2b;
    padding-left: 10px;
    font-size: 16px;
  }
  .sg-item{
    /*width: 575px;*/
    width:100%;
    height: 100%;
    padding:15px;
    display: flex;
  }
  .sg-pic{
    height: 100%;
    margin-right: 15px;
  }
  .sg-info{
    background: #f1f1f1;
    /*padding:10px;*/
    padding:1.73%;
    /*font-size: 15px;*/
    position: relative;
    flex:1
  }
  .info-foot{
    position:absolute;
    bottom: 10px;
    right: 10px;
    color: #ff7743;
    /*font-size: 13px*/
  }
  .duohang-slh{
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
  }
</style>
